import { render, staticRenderFns } from "./VehicleSuccess.vue?vue&type=template&id=2c810f73&scoped=true&"
import script from "./VehicleSuccess.vue?vue&type=script&lang=js&"
export * from "./VehicleSuccess.vue?vue&type=script&lang=js&"
import style0 from "./VehicleSuccess.vue?vue&type=style&index=0&id=2c810f73&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c810f73",
  null
  
)

export default component.exports